import styled from '@emotion/styled';

export const LogoWrapper = styled.div`
  padding-top: 69px;
`;

export const InputsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
